export const jsonFlatten = (obj, path = '') => {
    if (!(obj instanceof Object)) return {[path.replace(/\.$/g, '')]:obj};

    return Object.keys(obj).reduce((output, key) => {
        return obj instanceof Array ?
            {...output, ...jsonFlatten(obj[key], path +  '[' + key + '].')}:
            {...output, ...jsonFlatten(obj[key], path + key + '.')};
    }, {});
}